module.exports = __webpack_public_path__ + "img/Porto Apartment - 45 of 85.8b4bc9cb.jpeg";